import { provide } from 'vue'
import { VALIDATION_RULES_KEY, type AppValidationRules } from '@jms/utils'
import { lang } from '@jms/utils'

export function useValidationProvider() {
  const rules: AppValidationRules = {
  }
  provide(VALIDATION_RULES_KEY, rules)
}
